import {Panes, prefixWithSeparator, Select, TextField} from '@management-ui/core';
import {Box} from '@mui/material';
import React, {useCallback, useMemo} from 'react';
import {useFormContext} from 'react-hook-form';

const PRESETS = [
  '30 days', '30 days end of month', '7 days', 'Immediate payment on delivery', 'Other'
];

const Payment = ({order = {}, prefix = ''}) => {
  const {/** @var {function(string): string} */watch} = useFormContext();
  const preset = watch(useMemo(() => `${prefixWithSeparator(prefix)}preset`, [prefix]));

  const handleReset = useCallback((subject) => {
    if (subject.payment_terms) {
      const index = PRESETS.indexOf(subject.payment_terms ?? '');
      subject.preset = index >= 0 ? PRESETS[index] : 'Other';
    }
    return subject;
  }, []);

  return (
    <Panes
      entity={order}
      prefix={prefix}
      onReset={handleReset}
      panes={[
        {
          title: 'Payment Details',
          fields: [
            <Select
              name="preset"
              prefix={prefix}
              label="Payment Terms"
              options={PRESETS.map((t) => ({value: t, title: t}))}
            />,
            <Box display={preset !== 'Other' ? 'none' : 'block'}>
              <TextField
                name="payment_terms"
                prefix={prefix}
                label="Other"
                fieldProps={{multiline: true, rows: 2}}
              />
            </Box>
          ]
        },
        {
          title: '',
          fields: []
        }
      ]}
      title=""/>
  );
}

Payment.onSave = ({preset, payment_terms}) => preset === 'Other' ? {payment_terms} : {payment_terms: preset};

export default Payment;
